import { render, staticRenderFns } from "./unlockToView.vue?vue&type=template&id=39ffc968&scoped=true&"
import script from "./unlockToView.vue?vue&type=script&lang=js&"
export * from "./unlockToView.vue?vue&type=script&lang=js&"
import style0 from "./unlockToView.vue?vue&type=style&index=0&id=39ffc968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ffc968",
  null
  
)

export default component.exports